"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  jcb: {
    'opt-protect': {
      loginScan: 'Scan',
      passwordLogin: 'Code',
      smsDescribe: 'Current operation is sensitive, need to verify your identity through <strong>SMS</strong>',
      emailDescribe: 'Current operation is sensitive, need to verify your identity through <strong>Email</strong>',
      contentHelpLabel: {
        app: 'App'
      },
      qr: {
        introduction: 'Scan by JD Cloud & AI App',
        help: 'Help',
        download: 'Download',
        refresh: 'Refresh',
        fetchErrorMsg: 'Loading error'
      },
      form: {
        placeholder: 'Please input 6-digit verification code',
        placeholderSecurity: 'Please enter 6-digit security code',
        confirm: 'Verify',
        help: 'Help',
        download: 'Download',
        invalidateLength: 'Less than 6 digits in length',
        invalidateSecurityLength: 'Less than 6 digits in length',
        getVeriCode: 'verification code',
        replacePhone: 'Change mobile number',
        replaceEmail: 'Change email',
        invalidateType: 'Verification code must be number',
        invalidateSecurityType: 'Security code must be number'
      }
    },
    monitorDashboard: {
      colon: ': ',
      period: 'Period',
      aggregateType: 'Aggregation',
      noPermission: 'Please contact the administrator to add permissions.'
    },
    'tag-edit': {
      selectedResourceCount: 'Selected resource count: {count}',
      popupTitle: 'Add / Remove Tag',
      ruleText: 'Add/Remove Rule',
      emptyText: 'No Data',
      rule: {
        comment: "<p>Each tag consists of a \"key\" and a \"value\", for example: \"Department: Basic R&D\".</p>\n        <p>You can edit the tag of the selected resources on this page, click \"Add\" or \"Delete\" to bind and unbind the tags, then click \"Confirm\" at the bottom to submit your operation.</p>\n        <p>Each resource can be bound to up to 10 different tags. Only one tag \"value\" can exist on each tag \"key\" of the same resource.</p>",
        resourceIds: 'Supports editing tags of up to 100 resources at the same time. Please deselect some resources and try again.'
      },
      tagType: {
        tagTemplate: 'tagTemplate',
        tag: 'tag'
      },
      form: {
        rules: {
          selectValueLength: '1 to 255 characters in length',
          selectKeyLength: '1 to 127 characters in length',
          character: "The tag key/value can't start with \"jrn:\"\"jdc-\", only supports Chinese, letters, numbers and symbols\uFF1A _.,:/=+-@",
          notag: "can't name \"tag value\" to \"notag\""
        },
        currentTagLabel: 'Current Tag:',
        currentTagTable: {
          del: 'Delete',
          delAll: 'Delete All',
          tagKey: 'TagKey',
          tagValue: 'TagValue',
          multiTagValue: 'Multi-TagValue',
          resourceCount: 'Resurce Count',
          operation: 'Operate'
        },
        addTag: {
          label: 'Add Tag:',
          placeholder: 'Please Select',
          keyPrefix: 'Key',
          valuePrefix: 'Value',
          add: 'Add',
          invalided: 'Each resource can be bound to up to 10 different tags,please delete some tags and try again',
          invalidedResourceId: 'Resource id: {resourceId} exceeds maximum limit'
        },
        ok: 'OK',
        cancel: 'Cancel'
      },
      result: {
        resourceId: 'Resource ID: {resourceId}',
        updateComplete: 'Update resource tag commplete, There have ',
        haveFailedCount: ' failed, For reasons, please see the details below.',
        ok: 'OK',
        cancel: 'Cancel'
      }
    },
    'tag-filter': {
      title: 'Choose tag key / vlaue',
      placeholder: 'Enter key / value to search',
      filter: 'Filter',
      tooltip: 'Tag Filter',
      notag: 'NoTag',
      notagHelp: 'Select this item to filter resources that do not have the "label key".',
      emptyText: 'No Data'
    },
    'tag-creationform': {
      add: ' ADD',
      emptyText: 'No Data',
      key: 'key',
      value: 'value',
      placeholderKey: 'enter/select a key',
      placeholderValue: 'enter/select a value',
      tooltip: "<p>Each tag consists of a \"key\" and a \"value\", for example: \"Department: Basic R&D\"\uFF0C</p>\n                <p>you can manage resources in batches according to different dimensions by tags.</p>\n                <p>Tag can't start with \"jrn:\"\"jdc-\", only supports Chinese, letters, numbers and symbols\uFF1A</p>\n                <p> \"_.,:/=+-@\".<a target=\"_blank\" style=\"color: white;font-size: 12px;text-decoration: underline\" href=\"https://docs.jdcloud.com/cn/tag-service/product-overview\">more ></a></p>",
      rules: {
        selectValueLength: '1 to 255 characters in length',
        selectKeyLength: '1 to 127 characters in length',
        character: "Tag can't start with \"jrn:\"\"jdc-\", only supports Chinese, letters, numbers and symbols\uFF1A _.,:/=+-@",
        notag: "Can't name \"tag value\" to \"notag\"",
        requiredStrict: 'Can not be empty',
        requiredKey: 'Tag key can not be empty, Please adjunction and try again.',
        requiredValue: 'Tag value can not be empty, Please adjunction and try again.',
        maximumLimit: 'Each resource binds up to 10 tags, Please delete some tags and try again.',
        duplicateKey: 'Cannot contain duplicate tag keys, Please delete it and try again.'
      }
    },
    iaasDisk: {
      diskType: 'Type',
      type_sell_out: 'N/A',
      change_type: 'Sold out, please select another type',
      capacity: 'Capacity',
      snapshot: 'Snapshot',
      deviceName: 'DeviceName',
      data_name_range: 'Device name range of the data disk',
      see_detailRule: 'Click here for detailed rules',
      auto_assign_name: 'Auto-assign',
      release_with_vm: 'Release with VM',
      after_create_encrypt_no_change: 'The encryption attribute cannot be modified after disk creation',
      encrypt: 'Encrypt',
      encryption_cannot_change: 'The encryption attribute is inherited from snapshot and cannot be modified',
      exceed_specified_diskType_capacity: 'The selected snapshot capacity has exceeded the upper limit of the specified type of cloud disk'
    },
    'combined-search': {
      noMatchKey: 'No matching criteria, please re-enter',
      matchKeyExist: 'This criteria already exists',
      searchTip: 'Specify search criteria here for federated search',
      searchTipInEditMode: 'Press Enter to confirm.  Use"←" ，"→" key to select the search term that has been generated. Use Esc key to cancel the selection or collapse the drop-down box.',
      searchIconTip: 'Search will based on the search term that has been generated in the search box',
      clearIconTip: 'Clear search box',
      chooseFilterKey: 'Select searching criteria',
      confirm: 'OK',
      cancel: 'Cancel',
      noAvailableKey: 'Unmatched search criteria, "{0}" will be used as search criteria',
      activeTagTip: 'Click or Enter to edit',
      instructions: {
        help: 'Help',
        federatedSearchHelp: 'Federated Search Help',
        functionalTip: 'Federated search can help you search your VM(s) based on single or multiple search criteria.',
        useTip: 'You need to specify the search criteria then enter the search criteria value, use the Enter key to generate the search term, press Enter again or click the search icon to trigger search.',
        specSearchCriteria: 'Specify Search Criteria',
        specMethod: 'Specify Method',
        keyboardInput: 'keyboard input',
        dropdownSelect: 'drop-down box select',
        examples: 'Examples',
        exampleKeyLabel: 'Name',
        inputFormat: 'Input format',
        searchCriteria: '「search criteria」',
        colon: '「colon」',
        none: 'none',
        operationDisplay: 'Operation Display',
        enterSearchCriteriaValue: 'Enter Search Criteria Value',
        criteriaValueNumber: 'Criteria Value Number',
        singleValue: 'single',
        multiValue: 'multiple',
        specifiedSearchCriteria: 'search criteria specified',
        exampleSingleValueKey: 'Elastic IP Address',
        exampleMultiValueKey: 'Instance Type',
        searchCriteriaValue: 'search criteria value',
        enter: '「Enter」',
        comma: '「comma」',
        deleteSearchTerm: 'Delete Search Term',
        deleteScope: 'Delete Scope',
        all: 'all',
        deleteMethod: 'Delete Method',
        deleteByKeyboard: 'by keyboard',
        deleteByMouse: 'by mouse',
        deleteExampleTerm: 'Delete Search Term',
        egKeyBoardInput: 'Input "Instance Name:" ',
        egDropdownSelect: 'Click or Enter to select',
        egInputSingleSearchValue: 'Input search criteria value: 116.196.68.215, ',
        egInputMultiSearchValue: 'Input search criteria value: g.n2.medium,g.s2.small,c.c2.large, ',
        egPressEnter: 'press Enter to generate search term',
        egKeyboardDeleteTag: 'Use right or left arrow keys select search term，delete key to delete',
        egMouseDeleteTag: 'Click delete icon on search item to delete current search item',
        egKeyboardDeleteAll: 'Use Ctrl+A to select all search item, delete key to delete all',
        egMouseDeleteAll: 'Click delete icon on Federated Search to delete all'
      }
    },
    vpcLink: {
      name: 'Name',
      copy: 'Copy',
      cancel: 'Cancel',
      confirm: 'Confirm',
      copySuccess: 'Copyed',
      modifyName: 'Modify name',
      nameRequired: 'The name cannot be null.',
      nameLength: 'Length cannot exceed 32 characters.',
      nameChart: 'Name only supports Chinese characters, numbers, upper case and lower case letters, English underline "_" and line-through "-"'
    },
    'subnet-select': {
      lazyFailed: 'loading failed, please pull down to refresh...',
      emptyText: 'No Data',
      placeholder: 'Please Select',
      subnetId: 'Subnet ID',
      subnetName: 'Subnet Name',
      id: 'ID',
      name: 'name',
      inputKeyword: 'Enter {0} for {1} search',
      precise: 'precise',
      fuzzy: 'fuzzy'
    },
    'vpc-select': {
      placeholder: 'Please Select VPC',
      vpcId: 'VPC ID',
      vpcName: 'VPC Name',
      id: 'ID',
      name: 'name',
      inputKeyword: 'Enter {0} for {1} search',
      emptyText: 'No Data',
      precise: 'precise',
      fuzzy: 'fuzzy'
    },
    'ssh-select': {
      placeholder: 'Please Select SSH',
      noMatchText: 'No matching options',
      createSSH: 'Create New SSH',
      emptyText: 'No SSH',
      searching: 'Searching'
    },
    'securityGroup-select': {
      placeholder: 'Please Select Security Group',
      networkSecurityGroupId: 'Security Group ID',
      networkSecurityGroupName: 'Security Group Name',
      emptyText: 'No Data'
    },
    docHelp: {
      resetSize: 'Restore to original layout',
      helpTitle: 'Help documentation',
      close: 'close',
      goHelpCenter: 'Help Center',
      onlineConsultation: 'Online consultation'
    },
    'hosted-account-cascader': {
      systemAccount: 'System account',
      hostedAccount: 'Hosted account'
    },
    'vm-select': {
      placeholder: 'Please Select Vm',
      instanceId: '云主机ID',
      instanceName: '云主机名称',
      id: 'ID',
      name: '名称',
      inputKeyword: '输入{0}{1}搜索',
      emptyText: 'No Data',
      precise: '精确',
      fuzzy: '模糊'
    },
    hostedBill: {
      getUserInfoError: 'Failed to get user information',
      getHostedListError: 'Failed to get hosted user list',
      notifyTitle: 'Notify',
      hasCouponPermission: 'Has the authority to issue vouchers',
      buttonText: 'Buy Now',
      dialog: {
        hostedDialogTitle: 'Purchased for an escrow account',
        hostedDialogLabel: 'Purchased for an escrow account',
        hostedDialogVoucherLabel: 'Purchase with voucher'
      },
      error: {
        '0000': {
          title: 'Notify',
          text: 'The current {user} hosting relationship list is empty'
        },
        '0001': {
          title: 'Notify',
          text: 'The hosted account {hosted} is not hosted for the current account'
        },
        '0002': {
          title: 'Notify',
          text: 'Hosted account: The hosting permission of {hosted} is read-only and cannot be purchased for this account. It is recommended to inform the business to change to administrator permission and apply for hosting again'
        },
        '0003': {
          title: 'Notify',
          text: ''
        },
        '0004': {
          title: 'Notify',
          text: 'Exception, refresh the page and try again'
        }
      },
      actionSuccess: 'Voucher issued successfully',
      actionFail: 'Failed to issue voucher',
      buyNow: 'Buy Now',
      ok: 'Confirm',
      cancel: 'cancel'
    },
    errorNotify: {
      copy: 'Copy',
      copySuccess: 'Copyed',
      errorCode: 'ErrorCode',
      submitOrder: 'Create Work Order',
      defaultMsg: 'The network service resource configuration is abnormal. Please submit a work order for help!'
    },
    'az-selector': {
      soldOut: 'Sold out',
      unusableArea: 'Unusable area'
    },
    regionSelector: {
      tip: 'Sold out',
      noData: 'No region'
    },
    cidr: {
      range: 'Range'
    },
    chargeInfo: {
      chargeMode: {
        postpaid_by_duration: 'Pay by configuration',
        prepaid_by_duration: 'Monthly package',
        postpaid_by_usage: 'Pay by Consumption'
      },
      chargeItem: {
        maturity: 'Expired',
        expired: 'Expired',
        freed: 'Freed',
        arrear: 'Arrears'
      }
    },
    billPeriod: {
      months: {
        one: '{n} month',
        other: '{n} months'
      },
      years: {
        one: '{n} year',
        other: '{n} years'
      }
    },
    datetimeRangeSelector: {
      apply: 'apply',
      beginTime: 'begin time',
      endTime: 'end time',
      to: 'to',
      lastOneMonth: 'last 1 month',
      lastOneWeek: 'last 1 week',
      lastHours: 'last {n} hours',
      lastMinutes: 'last {n} minutes',
      today: 'today',
      yesterday: 'yesterday',
      thenDayBeforeYesterday: 'then day before yesterday',
      custom: 'custom',
      requiredValue: 'value is required',
      rangeError: 'Incorrect relative time range',
      cantFind: 'No corresponding RELATIVE_TIME_OPTIONS data found',
      tip: 'Please fill in a valid start time and end time'
    },
    'time-offset-selector': {
      ringRatio: 'Ring ratio',
      custom: 'Custom',
      periodTip: 'Forward based on the current query timespan',
      customTip: 'Select the start time, the system will automatically calculate the end time',
      donotcompare: "Don't compare",
      confirm: 'Confirm',
      period1: '1st cycle',
      periodmore1: 'First {num} cycles'
    },
    renew: {
      prepaid_by_duration: 'Renew',
      postpaid_by_duration: 'Switch to Monthly Package'
    },
    operationChck: {
      cannotOp: 'The current status of the instance does not allow operations.',
      noCharge: 'The current status of the billing does not allow operations.'
    },
    whiteList: {
      title: 'White list setting',
      modify: 'Setting',
      modifyTitle: 'White list setting',
      editMode: 'Edit method',
      editSuccess: 'Setting Success',
      textEdit: {
        title: 'Text edit',
        tipA: 'Assigned IP address: 192.168.0.1 access of IP address 192.168.0.1 is allowed',
        tipAIpv6: ', support IPV6 address.',
        tipB: 'Specify IP field：192.168.0.0/24 （Allow IP address access from 192.168.0.1 to 192.168.0.255）',
        tipBIpv6: ', support IPV6 CIDR.',
        tipC1: 'Multiple IP settings shall be ',
        tipC2: 'separated by English comma or carriage',
        tipC3: '',
        tipD: 'White list including 0.0.0.0/0 represents that all addresses are allowed for access. Please consider carefully.',
        tipDIpv6: 'The whitelist is set to "0.0.0.0/0" or ::/0 to allow access to all addresses. Please consider carefully.',
        ips: 'IP list：'
      },
      host: {
        title: 'VM selection',
        emptyText: 'No available virtual machine for the current VPC',
        tipVpc: 'Only the virtual machine in the VPC is listed here',
        tipMax1: 'You may also add',
        tipMax2: 'White list(s)',
        selectAll: 'Select all'
      },
      rules: {
        lengthMin: 'There must be at least one IP or IP segment in a white list',
        lengthMax: 'White list supports up to 50 Ips or IP segments',
        illegal: 'Submitted data include illegal IP(s) or IP segment(s), please check before submit again',
        duplicate: 'Submitted data include duplicate IP(s) or IP segment(s), please check before submit again',
        totalIps: 'The total number of whitelists cannot exceed {totalNum}'
      }
    }
  },
  loading: 'Loading',
  searching: 'Searching',
  confirm: 'Confirm',
  cancel: 'Cancel'
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/locale/lang/en.js
// module id = suGz
// module chunks = 19